module.exports = __webpack_public_path__ + "img/icon_index_kaipiao.ca0b20b7.png";